export const homeObjOne3 = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDes: true,
    topLine: 'Prestige Event & Catering ',
    headline: 'Catering för alla tillfällen',
    description: 'Maten är en av de viktigaste delarna av en lyckad tillställning – den samlar människor, skapar glädje och blir en del av upplevelsen som gästerna minns. På Prestige Catering Event vet vi hur viktigt det är att varje detalj känns genomtänkt. Med lång erfarenhet inom catering och event hjälper vi er hela vägen',
    imgStart: false,
    img: require('../../AssetsForCatering/closed-metal-pots.jpg'),
    alt: 'catering',
    dark: true,
    primary: true,
    darkText: false,
}